// extracted by mini-css-extract-plugin
export default {"container":"components-Modal-modal-module__container--J20WP","btn":"components-Modal-modal-module__btn--zPvM6","backdrop":"components-Modal-modal-module__backdrop--wVYMf"};